import AppSignal from '@appsignal/javascript';

export const appsignal = new AppSignal({
  key: import.meta.env.VITE_APP_APP_SIGNAL_KEY,
  revision: document.body.dataset.appRevision,
});
